'use client'

import { motion } from 'motion/react'
import { forwardRef } from 'react'
import { ITag } from '@/api/restaurants/types/restaurant-types'
import { SvgOutlinedCross } from '@/icons/svg-outlined-cross'
import { cn } from '@/utils/styles/cn'
import { COLORS } from '@/utils/styles/colors'

export interface ITagProps {
    tag: Omit<ITag, 'slug'>
    onClick?: () => void
    active?: boolean
    className?: string
}

export const Tag = forwardRef<HTMLDivElement, ITagProps>(
    ({ active, tag, onClick, className }, ref) => {
        return (
            <motion.div
                initial={{ backgroundColor: active ? COLORS.neotaste : '#F1F1F2' }}
                animate={{ backgroundColor: active ? COLORS.neotaste : '#F1F1F2' }}
                transition={{ duration: 0.1, ease: 'easeOut' }}
                ref={ref}
                onClick={onClick}
                className={cn(
                    'flex flex-row items-center justify-center px-4 py-2 rounded-full min-h-[40px] font-semibold w-fit',
                    className
                )}
                style={{
                    WebkitTapHighlightColor: 'transparent',
                    cursor: onClick ? 'pointer' : 'default',
                }}
            >
                {tag.emoji && <span className="mr-2">{tag.emoji}</span>}
                {tag.name}

                {active && onClick && (
                    <div className="flex items-center justify-center ml-2">
                        <SvgOutlinedCross size={20} color="black" />
                    </div>
                )}
            </motion.div>
        )
    }
)

Tag.displayName = 'Tag'
